import React from 'react';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { Layout } from './components/layout/Layout';
import Home from './pages/Home';
import FreeEstimate from './pages/FreeEstimate';
import ThankYou from './pages/ThankYou';
import ServicePage from './pages/ServicePage';
import OurWork from './pages/OurWork';
import ContactUs from './pages/ContactUs';
import Blog, { BlogPost } from './pages/Blog';
import { LocationsNJ, CountyPage, LocationServicePage, CityPage } from './pages/Locations';
import { POSTS } from './data/site';
import './App.css';

// Root-level catch-all: city SEO pages or blog post slugs (mirrors WordPress flat URL structure)
function RootSlug() {
  const { slug } = useParams();
  if (/-county-roof-repair-replacement-/.test(slug)) return <CityPage />;
  if (POSTS.some((p) => p.slug === slug)) return <BlogPost />;
  return <Home />;
}

// /locations/new-jersey/:slug -> county page OR service-in-county page
function NJSlug() {
  const { slug } = useParams();
  if (/-in-/.test(slug)) return <LocationServicePage />;
  return <CountyPageWrapper />;
}

function CountyPageWrapper() {
  return <CountyPage />;
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/free-estimate" element={<FreeEstimate />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/gutters" element={<ServicePage mainSlug="gutters" />} />
          <Route path="/siding" element={<ServicePage mainSlug="siding" />} />
          <Route path="/chimney-repair" element={<ServicePage mainSlug="chimney-repair" />} />
          <Route path="/roofing" element={<ServicePage mainSlug="roofing" />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/locations" element={<LocationsNJ />} />
          <Route path="/locations/new-jersey" element={<LocationsNJ />} />
          <Route path="/locations/new-jersey/:slug" element={<NJSlugRoute />} />
          <Route path="/locations/new-jersey/:county/:slug" element={<LocationServicePage />} />
          <Route path="/:slug" element={<RootSlug />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

function NJSlugRoute() {
  const { slug } = useParams();
  if (/-in-/.test(slug)) return <LocationServicePage />;
  return <CountyRoute />;
}

function CountyRoute() {
  return <CountyPage />;
}

export default App;
